import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

export const PopoverSettings = (params) => {
  const { showableCustomColumns, intialColumnsList, userPreferredColumn, onColumnSelectedApply, isDisabled,
    isOpen, setIsOpen } = params;

  const [selected, setSelected] = useState([]);
  //const [isOpen, setIsOpen] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (userPreferredColumn && userPreferredColumn.length > 0) {
      const select = showableCustomColumns.filter((item) => userPreferredColumn.includes(item))
      setSelected(select);
    }
  }, [userPreferredColumn]);

  useEffect(() => {
    if (selected.length === showableCustomColumns.length) {
      setSelectAll(true);
    } else {
      if (selectAll) setSelectAll(false);
    }
  }, [userPreferredColumn, selected]);

  const onCancel = () => {
    if (isOpen) {
      if (
        userPreferredColumn &&
        selected &&
        userPreferredColumn.length > 0 &&
        (selected.length > userPreferredColumn.length ||
          selected.length < userPreferredColumn.length)
      ) {
        setSelected(userPreferredColumn);
      } else if (selected.length > 0 && userPreferredColumn.length === 0) {
        setSelected([]);
      }
    }
    setIsOpen(!isOpen);
  };
  const onApply = () => {
    setIsOpen(!isOpen);
    onColumnSelectedApply(selected);
  };

  const onSelect = (item, checked) => {
    if (checked) setSelected([...selected, item]);
    else setSelected(selected.filter((e) => e !== item));
  };

  const onSelectAll = (checked) => {
    if (checked) {
      setSelected(showableCustomColumns);
    } else {
      setSelected([]);
    }
    setSelectAll(checked);
  };

  return (
    <div className="settings_popover_container ml-2">
      <div className="common_popover">
        {showableCustomColumns && showableCustomColumns.length > 0 ? (
          <div
            className={`common_popover_btn ${isOpen ? "opened" : ""} ${isDisabled ? "disabled" : ""} `}
            onClick={() => onCancel()}
          >
            <i className="fa fa-sliders" aria-hidden="true" />
          </div>
        ) : null}

        {isOpen && (
          <div className="popover popover-left">
            <div className="arrow arrow_left"></div>
            <div className="common_popoverBody">
              <div>
                <div className="label_content">
                  <div className={`dropdown-item-custom`}>
                    <label className="common_popover_lable">
                      <span>
                        <input
                          type="checkbox"
                          checked={selectAll}
                          disabled={false}
                          onChange={(e) => onSelectAll(e.target.checked)}
                        />
                      </span>
                      <span className="item-text">Select All</span>
                    </label>
                  </div>
                  {intialColumnsList.map((item) => {
                    return (
                      <div key={item.key} className={`dropdown-item-custom`}>
                        <label className="common_popover_lable">
                          <span>
                            <input
                              type="checkbox"
                              checked={selected.indexOf(item.key) >= 0}
                              disabled={false}
                              onChange={(e) => onSelect(item.key, e.target.checked)}
                            />
                          </span>
                          <span className="item-text">{item.label}</span>
                        </label>
                      </div>
                    );
                  })}
                </div>
                <div className="popover_footer">
                  <Button
                    disabled={selected.length > 0 ? false : true}
                    size="sm"
                    variant="success"
                    onClick={() => onApply()}
                  >
                    Apply
                  </Button>
                  <Button size="sm" variant="danger" onClick={() => onCancel()}>
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};